// Sentry initialization should be imported first!
import './instrument';

import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Report render errors to Sentry, including the ones caught by error boundaries (e.g. the layout's error page).
// The callbacks keep React's default console logging, which a custom handler otherwise replaces.
const reportError = Sentry.reactErrorHandler((error, errorInfo) => {
  console.error(error, errorInfo.componentStack);
});

ReactDOM.createRoot(document.getElementById('root')!, {
  onUncaughtError: reportError,
  onCaughtError: reportError,
}).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
